import { render, staticRenderFns } from "./two-factor-login-dialog.vue?vue&type=template&id=a76f9fc6&scoped=true"
import script from "./two-factor-login-dialog.vue?vue&type=script&lang=js"
export * from "./two-factor-login-dialog.vue?vue&type=script&lang=js"
import style0 from "./two-factor-login-dialog.vue?vue&type=style&index=0&id=a76f9fc6&prod&scoped=true&lang=scss"
import style1 from "./two-factor-login-dialog.vue?vue&type=style&index=1&id=a76f9fc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a76f9fc6",
  null
  
)

export default component.exports